import { Component, computed, effect, resource, Signal, signal } from '@angular/core';
import { AbstractComponent } from '../../abstract-component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { BackendService } from '../../services/backend.service';
import { HttpResourceRef } from '@angular/common/http';

@Component({
  selector: 'app-tests',
  imports: [
    ReactiveFormsModule
],
  templateUrl: './tests.component.html',
  styleUrl: './tests.component.css'
})
export class TestsComponent extends AbstractComponent {

  signal1 = signal(0);
  signal2 = signal(0);
  responseDhrHello = signal<any>(null);
/*
 userResource = resource({
    params: () => ({ count: this.signal1()}),
    loader: ({params}) => this.test(params),
  })
    signalBasadaEnResource = computed(() => {
      console.log('Signal based on resource updated');
      return this.userResource.value();
    });
  
*/
hello =  this.dhrService.helloResource
helloValueSignal = computed(() => {
        if (this.testResourceLanzado) {
        console.log('Hello value signal updated:', this.hello!.value());
        return this.hello!.value();
        } else {
          return undefined
        }
    });
testResourceLanzado = false
  formTests: FormGroup;


  

  loadData() { 
    if (this.testResourceLanzado) {  
      this.testResourceLanzado = false;   
      this.hello.reload();
    }

    /*
    console.log('Loading data...');
    

    this.dhrService.helloResource.isLoading();
    this.dhrService.helloResource2().subscribe({
      next: (response: any) => {
        console.log('Response from DhrService:', response);
        this.responseDhrHello.set(response);
      },
      error: (error: { message: string; }) => {
        console.error('Error from DhrService:', error);
        this.responseDhrHello.set('Error: ' + error.message);
      }
    });
    */
  }

  constructor(fb: FormBuilder, private backendService: BackendService,){
    super();
    this.formTests = fb.group({
      output: [' '],
      outputResource: [' '],
      output2: [' '],
      // Define your form controls here
      // Example: controlName: ['', Validators.required]
    });
    effect(() => {
      console.log('Signal 1 changed:', this.signal1());
    });
    effect(() => {
      console.log('Signal 2 changed:', this.signal2());
    });
    effect(() => {
      try {
      console.log('Effect: helloValueSignal changed:', this.helloValueSignal());
      //this.formTests.get('outputResource')?.setValue(this.helloStatusSignal());
      } catch (error) {
        console.error('Error in helloSignal effect:', error);
      }

    });
    
    // You can add more effects or signals as needed
  }
  
  incSignal1() {
    this.signal1.update(value => value + 1);
  }
  incSignal2() {
    this.signal2.update(value => value + 1);
  }
  ngOnInit(): void {
    console.log('Tests component initialized');
  }
  async test(params: { count: number; }){
    const retorno = `** retorno desde test${params.count}`
    return new Promise<number>((resolve) => {
      console.log(`Test started with count: ${params.count}`);
    setTimeout(() => {
      console.log(`Test executed with count: ${params.count}`);
      resolve(params.count) // Simulate an asynchronous operation;
    }, 1000);
  })};
    
  
  async test1() {
    console.log('Test 1 executed');
    await this.backendService.hello().subscribe({
      next: (texto) => {
        console.log('Response from backend:', texto);
        this.formTests.get('output')?.setValue(texto);
      },
      error: (error) => {
        console.error('Error from backend:', error);
        this.formTests.get('output')?.setValue('Error: ' + error.message);
      }
    });

    this.formTests.get('output')?.setValue('Test 1 executed');
  }
  async test1Resource() {
    console.log('Test 1 Resouce executed');
    this.testResourceLanzado = true
    this.loadData()
  }
    
    // Implement your test logic here
  
  async test2() {
    console.log('Test 2 executedd');
    const usuarios = await this.dhrService.getUsersCouchBase();
    console.log('Users from DhrService:', usuarios);
    const buffer = this.getJSON(usuarios)
    //const buffer = JSON.stringify(usuarios, null, 2);
    console.log(`** Buffer:${buffer}`);
    this.formTests.get('output2')!.setValue(buffer);    //this.formTests.get('output2')?.setValue(this.getJSON(usuarios));
    
  }
}
  // Additional methods can be added here if needed


